import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { CONTACT, SCOTT, SERVICES } from "@/lib/data";
import scottImg from "@/assets/brand/scott.png";
import lhgLogoWhite from "@/assets/brand/lhg_mark_white.png";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-blue-deep text-cream grain overflow-hidden">
      <div className="container-editorial relative z-10 pt-20 pb-14 border-b border-cream/10">
        <div className="grid md:grid-cols-[auto_1fr] gap-8 md:gap-12 items-center">
          <div className="relative w-32 h-32 md:w-40 md:h-40 shrink-0">
            <div className="absolute -inset-2 border border-amber/40" />
            <img
              src={scottImg}
              alt="Scott Bucher"
              className="w-full h-full object-cover object-top grayscale-[15%] relative z-10"
            />
          </div>
          <div>
            <p className="eyebrow text-amber-bright mb-3">Your Advisor</p>
            <h3 className="font-serif font-bold text-3xl md:text-4xl text-cream leading-tight">
              {SCOTT.name}
            </h3>
            <p className="font-body text-cream/60 mt-1">{SCOTT.title}</p>
            <p className="font-serif italic text-amber-bright/90 text-lg md:text-xl mt-5 max-w-2xl">
              &ldquo;{SCOTT.quote}&rdquo;
            </p>
          </div>
        </div>
      </div>

      <div className="container-editorial relative z-10 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div>
          <p className="eyebrow text-cream/40 mb-5">Explore</p>
          <ul className="space-y-3 font-body text-sm">
            {[
              ["/", "Home"],
              ["/services", "Services"],
              ["/about", "About Scott"],
              ["/family", "Family of Companies"],
              ["/resources", "Resources"],
              ["/insights", "Insights"],
              ["/contact", "Contact"],
            ].map(([to, label]) => (
              <li key={to}>
                <Link to={to} className="text-cream/70 hover:text-amber-bright transition-colors">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="eyebrow text-cream/40 mb-5">The Journey</p>
          <ul className="space-y-3 font-body text-sm">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link
                  to={s.slug === "exit-on-your-terms" ? "/services/exit-and-sell" : `/services/${s.slug}`}
                  className="text-cream/70 hover:text-amber-bright transition-colors"
                >
                  {s.code}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="eyebrow text-cream/40 mb-5">Contact</p>
          <ul className="space-y-4 font-body text-sm">
            <li>
              <a href={CONTACT.phoneHref} className="flex items-center gap-2 text-cream/70 hover:text-amber-bright transition-colors">
                <Phone size={15} /> {CONTACT.phone}
              </a>
            </li>
            <li>
              <a href={CONTACT.emailHref} className="flex items-center gap-2 text-cream/70 hover:text-amber-bright transition-colors break-all">
                <Mail size={15} /> {CONTACT.email}
              </a>
            </li>
            <li className="flex items-center gap-2 text-cream/70">
              <MapPin size={15} /> {CONTACT.location}
            </li>
            <li className="text-cream/50 pl-6">{CONTACT.serviceArea}</li>
          </ul>
        </div>

        <div>
          <p className="eyebrow text-cream/40 mb-5">Family of Companies</p>
          <ul className="space-y-3 font-body text-sm">
            <li><Link to="/family" className="text-cream/70 hover:text-amber-bright transition-colors">Logan Hunter Group</Link></li>
            <li><Link to="/services/exit-on-your-terms" className="text-amber-bright hover:text-cream transition-colors">Exit Strategy Experts</Link></li>
            <li><Link to="/zia" className="text-cream/70 hover:text-amber-bright transition-colors">Zia Risk Management</Link></li>
          </ul>
          <div className="mt-6 space-y-1">
            {CONTACT.domains.map((d) => (
              <p key={d} className="text-cream/40 text-xs flex items-center gap-1">
                <ArrowUpRight size={12} /> {d}
              </p>
            ))}
          </div>
        </div>
      </div>

      <div className="container-editorial relative z-10 py-8 border-t border-cream/10 flex flex-col sm:flex-row items-center justify-between gap-5">
        <img src={lhgLogoWhite} alt="Logan Hunter Group" className="h-12 w-auto object-contain opacity-90" />
        <p className="font-body text-xs text-cream/40">
          © {new Date().getFullYear()} Logan Hunter Group. All rights reserved.
        </p>
        <p className="eyebrow text-[0.6rem] text-cream/30">
          From your first day to your best last day
        </p>
        <Link
          to="/admin/login"
          data-testid="footer-admin-link"
          className="eyebrow text-[0.55rem] text-cream/25 hover:text-amber-bright transition-colors"
        >
          Admin
        </Link>
      </div>
    </footer>
  );
}
